import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function queryStripeConnectAccountUrl(): Promise<{
  url: string;
}> {
  const res = await fetchOrchidAPI(
    "/api/users/v1/orchid_pro/stripe_connect_create_account_url?agreed_to_contract_terms=true",
  );
  if (!res.ok) {
    throw new Error(`failed to get: ${getErrorDetail(await res.text())}`);
  }

  return res.json();
}
